module.exports = __webpack_public_path__ + "static/media/S1N6-2.1257683b.svg";